import { z } from 'zod';

/**
 * Version string for the TCPA SMS-consent text shown to the user. Bump this
 * whenever the consent copy changes so the saved record identifies which
 * version of the text was accepted. Format: ISO date, optional suffix.
 */
export const SMS_CONSENT_TEXT_VERSION = '2026-04-20';

/**
 * Append-only consent record stored under users/{uid}/sms-consents/{auto-id}.
 * The `users/{uid}.smsConsent` field mirrors the latest record for fast read.
 */
export const SmsConsentRecordSchema = z.object({
  phoneNumber: z.string(),
  consentTextVersion: z.string(),
  acceptedAt: z.unknown(), // Firestore Timestamp at runtime
  acceptedIpHash: z.string().nullable(),
  userAgent: z.string().nullable(),
});

export type SmsConsentRecord = z.infer<typeof SmsConsentRecordSchema>;

/**
 * Payload sent from client to the saveSmsConsent callable.
 */
export const SaveSmsConsentPayloadSchema = z.object({
  phoneNumber: z.string().min(1),
  consentTextVersion: z.string().min(1),
});

export type SaveSmsConsentPayload = z.infer<typeof SaveSmsConsentPayloadSchema>;
